type ConversationListMessage = {
  properties?: unknown;
};

const isTrueLike = (value: unknown): boolean =>
  value === true ||
  (typeof value === 'string' && value.trim().toLowerCase() === 'true');

export const messageAvoidsConversationList = (message: ConversationListMessage): boolean => {
  const properties = message.properties;
  if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
    return false;
  }

  return isTrueLike((properties as Record<string, unknown>).avoid_context);
};

export const isConversationListVisibleMessage = (message: ConversationListMessage): boolean =>
  !messageAvoidsConversationList(message);
